import { NavLink } from 'react-router-dom';
import { type ReactNode } from 'react';

import { cn } from '@utils/cn';

export interface SidebarNavItemProps {
  to: string;
  icon: ReactNode;
  label: string;
  badge?: ReactNode;
  end?: boolean;
  collapsed?: boolean;
  /** Called when the item is activated — used to dismiss the mobile drawer. */
  onNavigate?: () => void;
}

export default function SidebarNavItem({
  to,
  icon,
  label,
  badge,
  end,
  collapsed,
  onNavigate,
}: SidebarNavItemProps) {
  return (
    <NavLink
      to={to}
      end={end}
      onClick={onNavigate}
      className={({ isActive }) =>
        cn(
          'mx-2 my-[1px] flex items-center gap-2.5 overflow-hidden whitespace-nowrap rounded-lg py-2 text-[13.5px] font-medium text-t2 transition-colors',
          collapsed ? 'justify-center px-0' : 'px-3.5',
          'hover:bg-surface-2 hover:text-t1',
          isActive && 'bg-gold-dim font-semibold text-gold',
        )
      }
    >
      {({ isActive }) => (
        <>
          <span
            className={cn(
              'h-[18px] w-[18px] shrink-0 transition-opacity',
              isActive ? 'opacity-100' : 'opacity-70',
            )}
          >
            {icon}
          </span>
          {collapsed ? null : <span className="flex-1 truncate">{label}</span>}
          {!collapsed && badge ? <span className="shrink-0">{badge}</span> : null}
        </>
      )}
    </NavLink>
  );
}
